<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-10 is-offset-1 stepbar-padding">
          <div class="lc-intro-block">
            <h3 class="intro">Cool, from the list below choose the design that is most similar to what you’re looking for and let us know a few details about it</h3>
            <p>You can always change everything but we need to know where you want to start off</p>
          </div>
          <form
            @submit.prevent="onSubmit"
          >
            <div class="columns">
              <div class="column">
                <b-field
                  horizontal
                  label="my category is"
                  class="lc-field"
                >
                  <LCDropdownInput
                    v-model="form.productTargetSelect"
                    :options="targetOptions"
                    placeholder="select"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field
                  horizontal
                  label="style"
                  class="lc-field"
                  :class="{disabled: disabledStyleOptions}"
                >
                  <LCDropdownInput
                    v-model="form.productStyleSelect"
                    :options="styleOptionsForSelectedTarget"
                    :disabled="disabledStyleOptions"
                    :resetOnOptionsChange="true"
                    placeholder="select"
                  />
                </b-field>
              </div>
            </div>

            <transition-group
              name="list"
              tag="div"
              class="columns is-multiline is-mobile"
              :class="{'option-selected': (form.productId != null)}"
            >
              <div v-for="product in productsForOptions"
                  v-bind:key="product.id"
                  class="column is-4-mobile is-3-tablet"
              >
                <b-radio-button
                  v-model="form.productId"
                  :native-value="product.id"
                  class="lc-product"
                  @input="emitValidate"
                >
                  <img :src="product.frontMediumUrl" class="logo" />
                  <div class="product-title">{{product.name}}</div>
                </b-radio-button>
              </div>
            </transition-group>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  // import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import LCDropdownInput from '@/components/leads_catcher/LCDropdownInput.vue'

  export default {
    name: 'Product',
    components: {
      LCDropdownInput
    },
    props: {
      form: Object
    },
    mounted() {
      this.emitValidate()
      // this.form.productTargetSelect = undefined
      // this.form.productStyleSelect = undefined
      // this.$store.dispatch('categories/loadAll', {page: 1})
      this.$store.dispatch('categories/loadAllChildren', {})
    },
    computed: {
      ...mapGetters({
        categories: 'categories/allEntities',
        styles: 'styles/allEntities',
        products: 'products/allEntities'
      }),
      targetOptions() {
        let options = []
        Object.values(this.categories).forEach((c) => {
          options.push({label: c.name, value: String(c.id)})
        })
        return options
      },
      styleOptionsForSelectedTarget() {
        let options = []
        if (this.form.productTargetSelect) {
          let stylesArr = this.categories[parseInt(this.form.productTargetSelect.value)].styles
          stylesArr.forEach((s) => {
            options.push({label: this.styles[s].name, value: String(this.styles[s].id)})
          })
        }
        return options
      },
      disabledStyleOptions() {
        if (this.form.productTargetSelect) {
          // return this.styles[this.form.productTargetSelect.value] == undefined
          return false
        } else {
          return true
        }
      },
      productsForOptions() {
        let options = []

        if (this.form.productTargetSelect &&
            this.form.productStyleSelect) {
          let productsArr = this.styles[parseInt(this.form.productStyleSelect.value)].products
          productsArr.forEach((p) => {
            options.push(this.products[p])
          })
        }

        return options
      },
      selectsToWatch() {
        // hackish just to have a watcher for target or style changes
        let target = 'undefined'
        if (this.form.productTargetSelect) {
          target = this.form.productTargetSelect.value
        }

        let style = 'undefined'
        if (this.form.productStyleSelect) {
          style = this.form.productStyleSelect.value
        }

        return `${target}|${style}`;
      },
    },
    watch: {
      'form.productId'(newVal) {
        if ((newVal != null) && (this.$store) && (this.products[newVal] != undefined)) {
          const product = this.products[newVal]

          this.form.productTarget = this.form.productTargetSelect.label
          this.form.productStyle = this.form.productStyleSelect.label
          this.form.productModel = product.name
          this.form.productThumbnail = product.frontMediumUrl
          this.form.productThumbnailBack = product.backMediumUrl
        } else if (newVal == null || newVal == '') {
          this.form.productTarget = ''
          this.form.productStyle = ''
          this.form.productModel = ''
          this.form.productThumbnail = ''
          this.form.productThumbnailBack = ''
        }
      },
      selectsToWatch() {
        this.form.productId = null
        this.emitValidate()
      },
    },
    methods: {
      validate() {
        // return true
        return (this.form.productId != null)
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      }
    }
  }
</script>

<style lang="scss" scoped>
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale3d(0, 0, 1);
}
</style>
